'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var DownloadIcon = function DownloadIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === undefined ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['color', 'size', 'filled', 'className', 'children']);

  var classes = 'calcite-icon';
  if (className) classes += ' ' + className;

  if (size <= 16) {
    return _react2.default.createElement('svg', _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: '0 0 16 16',
      className: classes
    }), filled ? _react2.default.createElement('path', {
      d: 'M15.71 7.582a3.133 3.133 0 0 1-2.768 3.218H10V9.058h3.212a1.413 1.413 0 0 0 .888-1.362c0-1.248-1.096-1.47-2.272-1.928l-.17-1.249a2.826 2.826 0 0 0-2.64-2.577c-1.71 0-2.692 1.87-3.067 2.917 0 0-.856-.919-1.753-.495s-.516 1.222-.565 1.682l-.967.501A1.409 1.409 0 0 0 1.9 7.798a1.317 1.317 0 0 0 .887 1.26H6V10.8H3.058A3.078 3.078 0 0 1 .291 7.679a3.255 3.255 0 0 1 1.765-2.896 2.267 2.267 0 0 1 2.25-2.152 2.411 2.411 0 0 1 .639.096l.077.02.036-.071A4.437 4.437 0 0 1 8.964.2a4.607 4.607 0 0 1 4.413 4.111l.009.062.058.02a3.342 3.342 0 0 1 2.265 3.189zM5 11.801v1.198L8 16l3-3v-1.2h-1v1H9V7H7v5.8H6v-1z'
    }) : _react2.default.createElement('path', {
      d: 'M16 7.621A3.3 3.3 0 0 1 13.063 11H13v-1h.063A2.337 2.337 0 0 0 15 7.621a2.508 2.508 0 0 0-1.705-2.396l-.592-.196-.085-.618A3.808 3.808 0 0 0 8.988 1a3.652 3.652 0 0 0-3.205 2.039l-.37.714-.778-.21a1.592 1.592 0 0 0-.42-.067A1.34 1.34 0 0 0 2.86 4.75l-.04.56-.498.257A2.419 2.419 0 0 0 1 7.72 2.24 2.24 0 0 0 3 10h1v1H3a3.225 3.225 0 0 1-3-3.28 3.428 3.428 0 0 1 1.863-3.041 2.331 2.331 0 0 1 2.353-2.203 2.588 2.588 0 0 1 .68.101A4.64 4.64 0 0 1 8.988 0a4.788 4.788 0 0 1 4.622 4.275A3.515 3.515 0 0 1 16 7.621zm-7 5.656V6H8v7.277l-1.602-1.602-.707.707 2.809 2.81 2.81-2.81-.708-.707z'
    }));
  }

  if (size <= 24) {
    return _react2.default.createElement('svg', _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: '0 0 24 24',
      className: classes
    }), filled ? _react2.default.createElement('path', {
      d: 'M24 11.226A4.695 4.695 0 0 1 19.596 16H14v-2h5.595a2.708 2.708 0 0 0 2.406-2.774A3.175 3.175 0 0 0 19.797 8.2l-1.19-.387-.173-1.24A5.16 5.16 0 0 0 13.482 2a4.992 4.992 0 0 0-4.37 2.732L8.365 6.14l-1.538-.41a1.986 1.986 0 0 0-.504-.082 1.474 1.474 0 0 0-1.533 1.39l-.083 1.127-1.008.51a3.03 3.03 0 0 0-1.698 2.695A2.623 2.623 0 0 0 4.406 14H10v2H4.406a4.606 4.606 0 0 1-4.405-4.63 5.04 5.04 0 0 1 2.794-4.479 3.47 3.47 0 0 1 3.529-3.244 3.952 3.952 0 0 1 1.02.15A6.971 6.971 0 0 1 13.482 0a7.131 7.131 0 0 1 6.933 6.297 5.186 5.186 0 0 1 3.586 4.929zm-8 6.315l-3 2.93V12h-2v8.47l-3-2.93v2.153l4 4 4-4z'
    }) : _react2.default.createElement('path', {
      d: 'M24.001 11.226A4.695 4.695 0 0 1 19.596 16H16.05v-1h3.545A3.694 3.694 0 0 0 23 11.226a4.173 4.173 0 0 0-2.895-3.977l-.595-.193-.086-.62A6.164 6.164 0 0 0 13.483 1a5.988 5.988 0 0 0-5.254 3.265l-.373.703-.769-.206a2.966 2.966 0 0 0-.763-.116 2.473 2.473 0 0 0-2.532 2.319l-.041.563-.503.255A4.026 4.026 0 0 0 1 11.37 3.614 3.614 0 0 0 4.406 15h2.532v1H4.406a4.606 4.606 0 0 1-4.405-4.63 5.04 5.04 0 0 1 2.795-4.479 3.47 3.47 0 0 1 3.528-3.244 3.952 3.952 0 0 1 1.02.15A6.972 6.972 0 0 1 13.484 0a7.131 7.131 0 0 1 6.933 6.297A5.186 5.186 0 0 1 24 11.226zM12 20.294V8h-1v12.292l-2.646-2.646-.707.707 3.854 3.854 3.853-3.852-.707-.707z'
    }));
  }

  return _react2.default.createElement('svg', _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: '0 0 32 32',
    className: classes
  }), filled ? _react2.default.createElement('path', {
    d: 'M31.9 15.167C31.9 19.022 28.787 22 26 22h-7v-1.85h7.167c1.58 0 3.967-1.96 3.967-4.914a5.081 5.081 0 0 0-3.43-4.832l-1.182-.4-.177-1.237a7.709 7.709 0 0 0-7.361-6.817 7.416 7.416 0 0 0-6.475 4.052l-.754 1.413-1.551-.402a3.198 3.198 0 0 0-.804-.12 2.627 2.627 0 0 0-2.74 2.485l-.062 1.166-1.04.535a4.89 4.89 0 0 0-2.692 4.353c0 2.38 1.965 4.718 3.967 4.718H14V22H6C2.912 22 .1 18.784.1 15.36a6.802 6.802 0 0 1 3.733-6.061 4.572 4.572 0 0 1 4.692-4.337 5.073 5.073 0 0 1 1.293.182A9.278 9.278 0 0 1 17.95.1a9.577 9.577 0 0 1 9.22 8.42 6.988 6.988 0 0 1 4.73 6.647zM11 23.761v2.908L16.5 32l5.5-5.33v-2.91l-4 3.842V16h-3v11.602z'
  }) : _react2.default.createElement('path', {
    d: 'M32 15.704C32 19.308 29.13 22 26.562 22H23v-1h3.563C28.372 21 31 18.937 31 15.704a5.561 5.561 0 0 0-3.742-5.287l-.872-.297-.13-.911A8.153 8.153 0 0 0 18.462 2a7.848 7.848 0 0 0-6.859 4.294l-.556 1.045-1.146-.298a3.684 3.684 0 0 0-.923-.135 3.105 3.105 0 0 0-3.224 2.956l-.046.86-.765.394A5.37 5.37 0 0 0 2 15.897C2 18.521 4.157 21 6.438 21H10v1H6.437C3.592 22 1 19.092 1 15.897a6.369 6.369 0 0 1 3.486-5.67l.255-.131.016-.287a4.128 4.128 0 0 1 4.222-3.903 4.61 4.61 0 0 1 1.175.168l.382.099.185-.349A8.845 8.845 0 0 1 18.463 1a9.157 9.157 0 0 1 8.782 8.068l.044.304.29.099A6.559 6.559 0 0 1 32 15.704zM17 28.278V14h-1v14.278l-4.332-4.332-.707.707 5.539 5.54 5.54-5.54-.708-.707z'
  }));
};

exports.default = DownloadIcon;